import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import IndexPage from "../../../../Dashboard/Components/SecuritySettings/UserManagement/index";
import AddUser from "../../../../Dashboard/Components/SecuritySettings/UserManagement/AddUser";
import EditUser from "../../../../Dashboard/Components/SecuritySettings/UserManagement/EditUser";
import "../../../../../Assets/Styles/UserManagement.scss";

const UserManagementRoutes = (props) => {
  return (
    <BrowserRouter basename="/home/userManagement">
      <Switch>
        <Route path="/addUser">
          <AddUser LangData={props.LangData} />
        </Route>
        <Route path="/editUser">
          <EditUser LangData={props.LangData} />
        </Route>
        <Route path="/" exact>
          <IndexPage UserInfo={props.UserInfo} LangData={props.LangData} />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default UserManagementRoutes;
